import { Component } from 'react';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="table-header-subtitle">
                    <div>
                        <div className="d-flex align-items-center">
                            <div className="all-data-dot red mr-10"></div>{' '}
                            {t('commerce.detail.keywords.extraButtons.not_ranking')}
                        </div>
                        <div className="d-flex align-items-center">
                            <div className="all-data-dot green mr-10"></div>
                            {t('commerce.detail.keywords.extraButtons.ranking')}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ExtraButtons;
